module.exports = __webpack_public_path__ + "static/media/CargoCompactOnline_GeneralCondition_fr.0e8d6773.pdf";